import { useBootstrapData } from '../bootstrap-data/bootstrap-data-context';
export function useSettings() {
    const { data: { settings }, } = useBootstrapData();
    return settings;
}
